exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-item[data-v-69088202] {\n  margin-bottom: 5px;\n}\n.form-item .label[data-v-69088202] {\n    display: block;\n    margin-bottom: 3px;\n}\n", ""]);

// exports
